export const globalMixin = {
  mounted: function () {
  },
  methods: {
    hideLoading (loader) {
      if (loader) {
        loader.close()
      } else {
        const loaderEl = document.querySelector('.ct-loading-global')
        if (loaderEl) {
          document.body.removeChild(loaderEl)
        }
      }
    }
  }
}
